import AcademiaLoading from '../components/CommonComps/Loadings/AcademiaLoading';
import PageTitle from '../components/CommonComps/Titles/PageTitle';
import ClientPersonalInfo from '../components/ProfileComps/ClientPersonalInfo';
import CorporateInfo from '../components/ProfileComps/CorporateInfo';
import PersonalInfo from '../components/ProfileComps/PersonalInfo';
import { useAuthContext } from '../contexts/AuthProvider';
import useUserProfileActions from '../hooks/APIHooks/users/useUserProfileActions';
import { Client, User } from '../types/users';

const Profile = () => {
  // integration of context hooks here
  const { currentUser, currentUserType } = useAuthContext();

  // integration of custom API hooks here
  const { getUserProfileByIdHandler } = useUserProfileActions(
    '',
    currentUser ? (currentUser as User).user_profile_id : undefined
  );

  console.log('PROFILE DATA: ', getUserProfileByIdHandler.data?.data);

  // rendering profile page component here
  return (
    <>
      <PageTitle title='Profile' />

      {getUserProfileByIdHandler.isLoading ? (
        <AcademiaLoading />
      ) : (
        <>
          {currentUser ? (
            currentUserType === 'user' ? (
              <PersonalInfo
                currentUser={currentUser as User}
                userProfile={getUserProfileByIdHandler.data?.data}
              />
            ) : (
              <ClientPersonalInfo currentClient={currentUser as Client} />
            )
          ) : null}

          {currentUserType === 'user' ? (
            <CorporateInfo
              expertiseList={
                getUserProfileByIdHandler.data?.data.user_expertise || []
              }
              languages={
                getUserProfileByIdHandler.data?.data.languages_spoken || []
              }
            />
          ) : null}
        </>
      )}
    </>
  );
};

export default Profile;
